var l = { icon: { tag: "svg", attrs: { viewBox: "0 0 100 100", focusable: "false", fill: "currentColor" }, children: [{ tag: "path", attrs: { d: "M78.47 50l-6.33 6.25L27.85 100l-6.33-6.25L65.82 50 21.53 6.25 27.86 0l44.29 43.75z", "fill-rule": "nonzero" } }] }, name: "right-arrow", theme: "filled" };
export {
  l as default
};
